import {fetchRemoteResult} from "./api-util";
import securityApi from "../Util/security";

const controllerEndpoint = '/Settings/DivisionMiscellaneous/';
const apiEndpoint = '/api/SettingsDivisionMiscellaneous/';

const cache = {};

const validatePermission = (permissionGrantType) => {
    return securityApi.validatePermission(
        securityApi.Permissions.SettingsDivisionMiscellaneous,
        permissionGrantType
    );
};

//Certain values are fairly static, but retrieved multiple times
//don't waste valuable HTTP requests by caching our values
const fromCache = (name, generator) => {
    if(cache[name]){
        return cache[name];
    }
    
    return cache[name] = generator();
};

export default {
    getCategoryDropdownOptions(){
        return fetchRemoteResult(`${controllerEndpoint}CategoryDropdownOptions`);
    },
    getTypeDropdownOptions(){
        return fromCache(
            'getTypeDropdownOptions',
            () => fetchRemoteResult(`${controllerEndpoint}TypeDropdownOptions`)
        );
    },
    getCategory(id){
        return fetchRemoteResult(`${apiEndpoint}${id}`)
    },
    createCategory(model){
        return fetchRemoteResult(`${apiEndpoint}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(model)
        });
    },
    updateCategory(model){
        return fetchRemoteResult(`${apiEndpoint}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(model)
        });
    },
    deleteCategory(id){
        return fetchRemoteResult(`${apiEndpoint}${id}`, {
            method: 'DELETE'
        });
    },
    
    validateWritePermission(){
        return validatePermission(
            securityApi.PermissionGrantTypes.Write
        );
    },
    validateDeletePermission(){
        return validatePermission(
            securityApi.PermissionGrantTypes.Delete
        );
    }
}